import script from "./vip.vue?vue&type=script&lang=ts&setup=true"
export * from "./vip.vue?vue&type=script&lang=ts&setup=true"

import "./vip.vue?vue&type=style&index=0&id=5919188d&lang=css"

const __exports__ = script;

export default __exports__